import React, {useCallback, useEffect, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getIsSearchBoxActive} from 'modules/searchBox/selectors'
import {closeSearchBox} from 'modules/searchBox/slice'
import {motion} from 'motion/react'

import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock'
import {cssTheme} from '@vio/atlas/themes'

const ShadowElement = styled(motion.div)`
  background: ${cssTheme.colors.background.neutral.overlay};

  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 3;
`

const ANIMATION_DURATION = 0.2

export const SearchBoxShadow: React.FC = () => {
  const dispatch = useDispatch()
  const isVisible = useSelector(getIsSearchBoxActive)

  const ref = useRef<HTMLDivElement>()
  useBodyScrollLock({ref, isEnabled: isVisible})

  const closeOverlay = useCallback(() => {
    dispatch(closeSearchBox())
  }, [dispatch])

  const handleClick = useCallback(() => {
    closeOverlay()
  }, [closeOverlay])

  const onTouchMove = useCallback(() => {
    closeOverlay()
  }, [closeOverlay])

  useEffect(() => {
    if (onTouchMove && isVisible && ref.current) {
      ref.current.addEventListener('touchmove', onTouchMove)
    }

    return () => {
      if (onTouchMove && isVisible && ref.current) {
        ref.current.removeEventListener('touchmove', onTouchMove)
      }
    }
  }, [isVisible, onTouchMove, ref])

  return (
    isVisible && (
      <ShadowElement
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{
          duration: ANIMATION_DURATION
        }}
        ref={ref}
        onClick={handleClick}
      />
    )
  )
}
